import '~/js/modules/stickyNav';
import React, { Component } from 'react';
import GoFetch from '~/js/modules/fetch-wrapper';

const fetch = new GoFetch();

export default class ReviewsContent extends Component {
  state = {
    error: null,
    isLoaded: false,
    dataArray: [],
    rating: ['bad', 'poor', 'poor', 'good', 'excellent'],
    words: [
      'Bad',
      'Poor',
      'Not satisfied',
      'Unsatisfied',
      'Unsatisfactory',
      'As above',
      'Mentioned above',
      'Mentioned in the customer review',
      'As mentioned in main review',
      'Previously mentioned',
      'A little worn',
      'Building work',
      'Seaweed',
      'Disappointed',
      'Disappointing'
    ],
    resortCode: window.beaches_app.page.rstCode
  };

  componentDidMount() {
    this.getData();
  }

  matchWords = (string, array) => {
    let isMatch = false;

    if (array.length > 0) {
      for (const item of array) {
        const re = new RegExp('( |\n|>|^)' + item + '( |.|,|\n|<|$)', 'i');

        if (string.match(re) !== null) {
          isMatch = true;
          break;
        }
      }
    }

    return isMatch;
  };

  pushNewItem = array => {
    array.map(item => {
      let name;
      let location;
      let date;

      date = new Date(item.HREVIEWDATE);
      date = date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });

      if (
        item.PUBLICCUSTOMER !== undefined &&
        item.PUBLICCUSTOMER.NAME !== undefined
      ) {
        name = item.PUBLICCUSTOMER.NAME;
        if (name !== '') {
          name = name.split(' ')[0];
        }
      }

      if (
        item.PUBLICCUSTOMER !== undefined &&
        item.PUBLICCUSTOMER.LOCATION !== undefined
      ) {
        location = 'From ' + item.PUBLICCUSTOMER.LOCATION;
      }

      if (
        item.PRODUCTSTARRATING >= 4 &&
        item.CUSTOMERCOMMENT.length > 0 &&
        !this.matchWords(item.CUSTOMERCOMMENT, this.state.words)
      ) {
        const newItem = {
          index: item.COUNT,
          rating: item.PRODUCTSTARRATING - 1,
          date,
          name: name || 'Trusted Customer',
          location: location || '',
          comment: item.CUSTOMERCOMMENT
        };

        this.state.dataArray.push(newItem);
      }
    });
  };

  getData = () => {
    fetch.post(`/feefo/?resortCode=${this.state.resortCode}`, null, {})
      .then(
        result => {
          const resultArray = result.data.feefo.FEEDBACKLIST.FEEDBACK;

          this.pushNewItem(resultArray);

          this.setState({
            isLoaded: true
          });
        },
        error => {
          this.setState({
            isLoaded: true,
            error
          });
        }
      );
  };

  renderView = () => {
    let view;
    const { error, isLoaded, dataArray, rating } = this.state;

    console.log(dataArray);

    if (error) {
      view = (
        <div className="feefo-reviews-content-error">
          Error: {error.message}
        </div>
      );
    } else if (!isLoaded) {
      view = <div className="feefo-reviews-content-loading">Loading...</div>;
    } else if (dataArray.length === 0) {
      view = (
        <div className="feefo-reviews-content-loading">No reviews yet</div>
      );
    } else {
      view = (
        <div className="feefo-reviews-list container">
          {dataArray.map(item => (
            <div className="feefo-reviews-list-item" key={item.index}>
              <h2 className="feefo-reviews-list-item-rating">
                <span className="feefo-reviews-list-item-rating-title">
                  {rating[item.rating]}
                </span>
              </h2>
              <div className="feefo-reviews-list-item-content">
                <div className="feefo-reviews-list-item-top-row">
                  <div className="feefo-reviews-list-item-user hidden-xs">
                    <p className="feefo-reviews-list-item-user-name">
                      {item.name}
                    </p>
                    {/* <p className="feefo-reviews-list-item-user-from">
                      {item.location}
                    </p> */}
                  </div>
                  <p className="feefo-reviews-list-item-reviewed">
                    <span className="feefo-reviews-list-item-reviewed-text">
                      Reviewed
                    </span>{' '}
                    {item.date}
                  </p>
                </div>
                <div className="feefo-reviews-list-item-user visible-xs">
                  <p className="feefo-reviews-list-item-user-name">
                    {item.name}
                  </p>
                  {/* <p className="feefo-reviews-list-item-user-from">
                    {item.location}
                  </p> */}
                </div>
                <p
                  className="feefo-reviews-list-item-text"
                  dangerouslySetInnerHTML={{ __html: item.comment }}
                />
              </div>
            </div>
          ))}
        </div>
      );
    }

    return view;
  };

  render() {
    return this.renderView();
  }
}

const reactReviews = document.getElementById('reactContent');

ReactDOM.render(<ReviewsContent />, reactReviews);
